export default "__VITE_ASSET__$RFfoMC___"